import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import MicrosoftIcon from 'flow/components/icons/MicrosoftIcon';
import HubspotIcon from 'flow/components/icons/HubspotIcon';
import ZendeskIcon from 'flow/components/icons/ZendeskIcon';
import FreshdeskIcon from 'flow/components/icons/FreshdeskIcon';
import FreshserviceIcon from 'flow/components/icons/FreshserviceIcon';
import SalesforceIcon from 'flow/components/icons/SalesforceIcon';
import TelavoxIcon from 'flow/components/icons/TelavoxIcon';
import { getIntegrationHost } from 'flow/utils/is-integration';
import { jsx as _jsx } from "react/jsx-runtime";
export var CTI_HOST_DESCRIPTION = {
  HUBSPOT: 'HubSpot',
  ZENDESK: 'Zendesk',
  FRESHDESK: 'Freshdesk',
  FRESHSERVICE: 'Freshservice',
  SALESFORCE: 'Salesforce',
  MICROSOFT_DYNAMICS: 'Microsoft Dynamics 365',
  TELAVOX_PARTNER: 'Telavox Partner',
  DEFAULT: 'CTI Integration'
};
var defaultConfig = {
  description: CTI_HOST_DESCRIPTION.DEFAULT,
  allowMultipleInstancesOnOpen: false
};
var createConfig = function createConfig(overloads) {
  return _objectSpread(_objectSpread({}, defaultConfig), overloads);
};
var CTI_CONFIG = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CTI_HOST_DESCRIPTION.HUBSPOT, createConfig({
  description: CTI_HOST_DESCRIPTION.HUBSPOT,
  allowMultipleInstancesOnOpen: true
})), CTI_HOST_DESCRIPTION.MICROSOFT_DYNAMICS, createConfig({
  description: CTI_HOST_DESCRIPTION.MICROSOFT_DYNAMICS
})), CTI_HOST_DESCRIPTION.ZENDESK, createConfig({
  description: CTI_HOST_DESCRIPTION.ZENDESK
})), CTI_HOST_DESCRIPTION.FRESHDESK, createConfig({
  description: CTI_HOST_DESCRIPTION.FRESHDESK
})), CTI_HOST_DESCRIPTION.FRESHSERVICE, createConfig({
  description: CTI_HOST_DESCRIPTION.FRESHSERVICE
})), CTI_HOST_DESCRIPTION.SALESFORCE, createConfig({
  description: CTI_HOST_DESCRIPTION.SALESFORCE
})), CTI_HOST_DESCRIPTION.TELAVOX_PARTNER, createConfig({
  description: CTI_HOST_DESCRIPTION.TELAVOX_PARTNER
}));
var getConfigByDescription = function getConfigByDescription(description) {
  return CTI_CONFIG[description] ? CTI_CONFIG[description] : createConfig();
};
export var allowMultipleInstancesOnOpen = function allowMultipleInstancesOnOpen(hostSystemDescription) {
  return getConfigByDescription(hostSystemDescription).allowMultipleInstancesOnOpen;
};
export var getCtiHostIcon = function getCtiHostIcon(hostDescription) {
  switch (hostDescription) {
    case CTI_HOST_DESCRIPTION.HUBSPOT:
      return /*#__PURE__*/_jsx(HubspotIcon, {});
    case CTI_HOST_DESCRIPTION.ZENDESK:
      return /*#__PURE__*/_jsx(ZendeskIcon, {});
    case CTI_HOST_DESCRIPTION.FRESHDESK:
      return /*#__PURE__*/_jsx(FreshdeskIcon, {});
    case CTI_HOST_DESCRIPTION.FRESHSERVICE:
      return /*#__PURE__*/_jsx(FreshserviceIcon, {});
    case CTI_HOST_DESCRIPTION.SALESFORCE:
      return /*#__PURE__*/_jsx(SalesforceIcon, {});
    case CTI_HOST_DESCRIPTION.MICROSOFT_DYNAMICS:
      return /*#__PURE__*/_jsx(MicrosoftIcon, {
        size: 12
      });
    case CTI_HOST_DESCRIPTION.TELAVOX_PARTNER:
      return /*#__PURE__*/_jsx(TelavoxIcon, {});
    default:
      return null;
  }
};
export var getCtiHost = function getCtiHost() {
  var integrationHost = getIntegrationHost();
  return integrationHost === null ? CTI_HOST_DESCRIPTION.DEFAULT : integrationHost.toLowerCase();
};
export var getLocalStorageSettingsKey = function getLocalStorageSettingsKey() {
  return "tvx:settings:cti:".concat(getCtiHost());
};